import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isEqual, get, isEmpty } from 'lodash';
import { InstantSearch, Configure } from 'react-instantsearch/dom';
import { resetFilters } from 'actions/learn/search';
import SearchConfigProvider from './SearchConfigProvider';
import Layout from '../shared/Layout';
import Results from './Results';
import AlgoliaTracking from './AlgoliaTracking';
import Sidebar from './Sidebar';
import ApplyFilters from './ApplyFilters';

class Search extends Component {
  state = {
    searchState: {},
  };

  componentWillUnmount() {
    this.props.resetFilters();
  }

  /**
   * <InstantSearch> is in controlled mode so we have to maintain the
   * searchState manually within this component. See comment below.
   */
  onSearchStateChange = searchState => {
    const nextSearchState = { ...searchState };
    nextSearchState.indices = get(nextSearchState, 'indices', {});
    // Since our SearchBox (the search input) lives outside the InstantSearch
    // context, updating the search query will not reset the pages of each index
    // if the "Show More" button is clicked. Therefore we would have to reset
    // them manually when the search state changes.
    if (
      !isEmpty(this.state.searchState) &&
      !isEqual(searchState.configure, this.state.searchState.configure)
    ) {
      Object.keys(nextSearchState.indices).forEach(indexName => {
        Object.assign(nextSearchState.indices[indexName], { page: 1 });
      });
    }
    this.setState({ searchState: nextSearchState });
  };

  render() {
    return (
      <SearchConfigProvider>
        {({ loading, credentialsProps, indexes, query }) => (
          <Layout.Main>
            <Layout.Side>
              <Sidebar />
            </Layout.Side>
            <Layout.Content>
              {loading && t('common.loading')}
              {!loading && (
                <InstantSearch
                  {...credentialsProps}
                  searchState={this.state.searchState}
                  onSearchStateChange={this.onSearchStateChange}
                >
                  <Configure query={query} snippetEllipsisText="..." />
                  <ApplyFilters />
                  <Results indexes={indexes} />
                  <AlgoliaTracking indexes={indexes} query={query} />
                </InstantSearch>
              )}
            </Layout.Content>
          </Layout.Main>
        )}
      </SearchConfigProvider>
    );
  }
}

const mapDispatchToProps = {
  resetFilters,
};

export default connect(null, mapDispatchToProps)(Search);
